import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/changeAssignee', params).then((response) => {
        return response.data;
    });
};
export const useMutationChangeAssignee = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    cardId: string | number;
    isVirtual: boolean;
    username: string;
    versionId: number;
}
